import { clsx } from 'clsx';
import { type FC, type PropsWithChildren } from 'react';

import { type PublisherCardLayoutContainerProps } from '../../types';

import styles from './PublisherCardLayout.css';

type PublisherCardLayoutProps = Pick<PublisherCardLayoutContainerProps, 'brandingLevel'> & {
  isCompact: boolean;
};

export const PublisherCardLayout: FC<PropsWithChildren<PublisherCardLayoutProps>> = props => {
  const { brandingLevel, isCompact, children } = props;

  return (
    <div
      className={clsx(
        styles['container'],
        isCompact && styles['compact'],
        brandingLevel === 'thirdLevel' && styles['container--platinum'],
      )}
    >
      {children}
    </div>
  );
};
